import { DataTable } from "@/components/data-table";
import { Form } from "@/components/form";
import { formatNumber, formatString } from "@/shared/formats";
import { alpha, Stack, Typography } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import { Articulo } from "@/shared/types/articulo";

interface ArticuloTransferenciaArticuloItem {
    articulo?: Articulo;
    articuloId: string;
    cantidad: number;
    stockDisponible?: number;
}

interface ArticuloTransferenciaArticuloListProps {
    items: ArticuloTransferenciaArticuloItem[],
    remove?: (index: number) => void,
}

// Fila sin stock suficiente en el depósito origen seleccionado (solo si el stock es conocido).
const sinStock = (row: ArticuloTransferenciaArticuloItem) => row.stockDisponible != null && row.cantidad > row.stockDisponible;

export default function ArticuloTransferenciaArticuloList({
    items,
    remove = () => { }
}: ArticuloTransferenciaArticuloListProps) {
    return <Stack gap={1} flex={1} minHeight={"350px"}>
        <Stack direction={"row"} alignItems={"center"}>
            <Typography variant="h6" flex={"1 1 auto"}>Artículos</Typography>
        </Stack>
        <DataTable flex={1}>
            <DataTable.Content
                fit="flex"
                rows={items}
                getRowSx={row => sinStock(row)
                    ? { "&&&": { backgroundColor: theme => alpha(theme.palette.error.main, 0.12) } }
                    : undefined}
                columns={[
                    { header: "#", render: (_, index) => formatNumber(index + 1), width: "auto" },
                    {
                        header: "Nombre", render: row => <Stack>
                            {formatString(row.articulo?.nombre)}
                            {sinStock(row) && <Typography variant="caption" color="error">
                                Stock insuficiente (disponible: {formatNumber(row.stockDisponible!)})
                            </Typography>}
                        </Stack>
                    },
                    { header: "Cantidad (uds.)", render: row => formatNumber(row.cantidad), align: "right" },
                    {
                        header: "", render: (_, index) => <Form.IconButton size="small" onClick={() => remove(index)}>
                            <ClearIcon fontSize="small" />
                        </Form.IconButton>, width: "auto", align: "center"
                    }
                ]}
            />
        </DataTable>
    </Stack>
}